import React from "react";
import Input from "../../../Components/Control/Input";
import Group from "../../../Components/Group";
import './index.css';
import Button from "../../../Components/Control/Button";
import {Tool} from "../../../App";
import Notif from "../../../Components/Notif";
import User from "../../../Server/User";
import ValidationSpot from "../../../Components/Control/ValidationSpot";
import Check from "../../../Components/Control/Check";
import Select from "../../../Components/Control/Select";
import {connect} from "react-redux";
import {updateGrid} from "../../../Redux/Actions/grid";
import Resource from "../../../Resource";
import Perms from '../../../Perms';
import MyComponent from '../../../Components/MyComponent';

class PageSetting extends MyComponent {
    constructor(props) {
        super(props);

        if (!Perms().SETTINGS.VIEW)
            props.history.push(Resource.ROUTE.HOME);

        this.state = {
            pinStates: [
                {id: '', text: 'پین نشود'},
                {id: 'left', text: 'پین به چپ'},
                {id: 'right', text: 'پین به راست'}
            ],
            gridThemes: [
                {id: 'alpine', text: 'تم آلپین'},
                {id: 'balham', text: 'تم بلهم'}
            ],
            fields: {
                gridShowParentHeader: props.gridDefaultSettings.showParentHeader,
                gridShowHeaderFilters: props.gridDefaultSettings.showHeaderFilters,
                gridTheme: [{id: props.gridDefaultSettings.gridTheme || ''}],
                gridPinStatusColumn: [{id: props.gridDefaultSettings.pinStatusColumn || ''}],
                gridPinOperationColumn: [{id: props.gridDefaultSettings.pinOperationColumn || ''}]
            }
        };

        this.ref = {
            oldPassword: React.createRef(),
            passWord: React.createRef(),
            rePassword: React.createRef(),
            passwordCheck: React.createRef(),
            changePassButton: React.createRef(),
            gridShowParentHeader: React.createRef(),
            gridShowHeaderFilters: React.createRef(),
            gridPinStatusColumn: React.createRef(),
            gridPinOperationColumn: React.createRef()
        };
    }

    validations = {
        oldPassword: x => Boolean(x) || 'رمزعبور فعلی خود را وارد کنید.',
        passWord: x => Boolean(x) || 'رمزعبور جدید را وارد کنید.',
        rePassword: x => Boolean(x) || 'تکرار رمزعبور را وارد کنید.',
        passwordCheck: _ => !Boolean(this.state.fields?.passWord && this.state.fields?.rePassword) ||
            this.state.fields?.passWord === this.state.fields?.rePassword ||
            'رمزعبور با تکرار آن برابر نیست.'
    };

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        const {state, props} = this;

        return state.fields !== nextState.fields ||
            props.gridDefaultSettings !== nextProps.gridDefaultSettings;
    }

    render() {
        const {state} = this;

        return <div className={'PageSetting'}>
            <div className={'pad-e-4 pad-4x-e-0 pad-4x-b-4 fb-10 fb-4x-20'}>
                <Group title={'تغییر رمز عبور'}>
                    <div className="dis-f">
                        <Input ref={this.ref.oldPassword} type={"password"} className={'pad-4 fb-20'} label={'رمز عبور فعلی'} value={state.fields?.oldPassword} validation={this.validations.oldPassword} onChange={this.setField.bind(this, 'oldPassword')}/>
                        <ValidationSpot ref={this.ref.passwordCheck} className={'dis-f fb-20'} validation={this.validations.passwordCheck}>
                            <Input ref={this.ref.passWord} type={"password"} className={'pad-4 fb-10 fb-2x-20'} label={'رمز عبور جدید'} value={state.fields?.passWord} validation={this.validations.passWord} onChange={this.setField.bind(this, 'passWord')}/>
                            <Input ref={this.ref.rePassword} type={"password"} className={'pad-4 fb-10 fb-2x-20'} label={'تکرار رمز عبور جدید'} value={state.fields?.rePassword} validation={this.validations.rePassword} onChange={this.setField.bind(this, 'rePassword')}/>
                        </ValidationSpot>
                        <div className=" fb-2"></div>
                        <div className="flex"></div>
                        <Button refer={this.ref.changePassButton} className={'mar-4'} theme={"blue"} onClick={this.changePassClickHandler.bind(this)}>ثبت</Button>
                    </div>
                </Group>
            </div>
            <div className={'pad-s-4 pad-4x-s-0 pad-4x-t-4 fb-10 fb-4x-20'}>
                <Group title={'تنظیمات عمومی جدول‌ها'}>
                    <div className="dis-f">
                        <Check className={'fb-20'} label={'گروه بندی ستون‌های مربوط به هر موضوع'} checked={state.fields?.gridShowParentHeader} onChange={this.setField.bind(this, 'gridShowParentHeader')}/>
                        <Check className={'fb-20'} label={'نمایش عناوین فیلتر شده زیر سر ستون‌ها'} checked={state.fields?.gridShowHeaderFilters} onChange={this.setField.bind(this, 'gridShowHeaderFilters')}/>
                        <Select className={'pad-4 fb-20 fb-2x-20'} label={'تم'} options={state.gridThemes} value={state.fields?.gridTheme} onChange={this.setField.bind(this, 'gridTheme')}/>
                        <Select className={'pad-4 fb-10 fb-2x-20'} label={'پین ستون وضعیت'} options={state.pinStates} value={state.fields?.gridPinStatusColumn} onChange={this.setField.bind(this, 'gridPinStatusColumn')}/>
                        <Select className={'pad-4 fb-10 fb-2x-20'} label={'پین ستون عملیات'} options={state.pinStates} value={state.fields?.gridPinOperationColumn} onChange={this.setField.bind(this, 'gridPinOperationColumn')}/>
                    </div>
                </Group>
            </div>
            <div className={'pad-e-4 pad-4x-e-0 pad-t-8 fb-10 fb-4x-20'}>
                <Group title={'تنظیمات پرینتر'}>
                    <div className="dis-f">
                        <div className="flex"></div>
                        <a href={Resource.EXE.PRINTER}><Button theme={'green'}>دانلود فایل نصبی</Button></a>
                    </div>
                </Group>
            </div>
        </div>;
    }

    changePassClickHandler() {
        const {state} = this;
        if (this.passwordChangeValidate()) {
            this.ref.changePassButton.current.loading();

            User.changePassword({
                oldPassword: state.fields?.oldPassword,
                passWord: state.fields?.passWord,
                rePassword: state.fields?.rePassword
            })
                .then(_ => {
                    new Notif({message: 'رمزعبور با موفقیت تغییر یافت.'}).show();

                    this.setState({
                        fields: {
                            ...state.fields,
                            oldPassword: undefined,
                            passWord: undefined,
                            rePassword: undefined
                        }
                    });

                    this.ref.changePassButton.current.loading(false);
                })
                .catch(message => {
                    new Notif({message, theme: 'error'}).show();

                    this.ref.changePassButton.current.loading(false);
                });
        }
    }

    fieldWillUpdate(keys, value, currentFields, nextFields) {
        const {props} = this;

        switch (keys[0]) {
            case 'gridShowParentHeader':
                props.updateGrid({
                    ...props.gridDefaultSettings,
                    showParentHeader: value || false
                });
                break;
            case 'gridShowHeaderFilters':
                props.updateGrid({
                    ...props.gridDefaultSettings,
                    showHeaderFilters: value || false
                });
                break;
            case 'gridTheme':
                props.updateGrid({
                    ...props.gridDefaultSettings,
                    gridTheme: value[0].id
                });
                break;
            case 'gridPinStatusColumn':
                props.updateGrid({
                    ...props.gridDefaultSettings,
                    pinStatusColumn: value[0].id || false
                });
                break;
            case 'gridPinOperationColumn':
                props.updateGrid({
                    ...props.gridDefaultSettings,
                    pinOperationColumn: value[0].id || false
                });
                break;
            default:
        }
    }

    passwordChangeValidate() {
        const validate = Tool.validate(
            this.ref.oldPassword,
            this.ref.passWord,
            this.ref.rePassword,
            this.ref.passwordCheck);

        if (validate !== true)
            new Notif({message: validate.message, theme: 'error'}).show();

        return validate === true;
    }
}

const mapStateToProps = state => {
    return {
        gridDefaultSettings: state.grid.defaultSettings
    };
};

const mapDispatchToProps = dispatch => {
    return {
        updateGrid: settings => dispatch(updateGrid('defaultSettings', settings))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PageSetting);